export const LOAD_USER_INFO = "[USER_INFO] LOAD_USER_INFO";

export const UPDATE_FILTER = "[USER_INFO] UPDATE_FILTER";

export const LOAD_USER_PROJECTS = "[USER_INFO] LOAD_USER_PROJECTS";
